import React, { useState } from "react";
import {
    FormControl,
    MenuItem,
    Select,
    Typography,
    ListItemIcon,
    BaseSelectProps,
} from "@mui/material";
import { CheckIcon, Chevron } from "../../assets/files";
import { capitalizeFirstLetter } from "../../constants/formats";

interface IOptions {
    value: string | number;
    label?: string;
}

interface IProps extends BaseSelectProps<string | any> {
    label?: string;
    value: string | number;
    options: IOptions[];
}

const CustomSelect: React.FC<IProps> = ({
                                            label,
                                            value,
                                            onChange,
                                            options,
                                            ...selectProps
                                        }) => {
    const [open, setOpen] = useState(false);

    return (
        <FormControl fullWidth>
            {label && (
                <Typography variant="h2" mb={2}>
                    {label}
                </Typography>
            )}

            <Select
                {...selectProps}
                value={value}
                onChange={onChange}
                IconComponent={() => <Chevron rotate={open ? 180 : 0} />}
                onOpen={(e) => {
                    setOpen(true);
                    selectProps.onOpen?.(e);
                }}
                onClose={(e) => {
                    setOpen(false);
                    selectProps.onClose?.(e);
                }}
                renderValue={(selected) => capitalizeFirstLetter(String(selected))}
            >
                {options.map((e, i) => {
                    const optionValue = e.value;
                    const optionLabel = e.label ?? e.value;

                    return (
                        <MenuItem key={i} value={optionValue}>
                            <ListItemIcon>
                                {value === optionValue && <CheckIcon />}
                            </ListItemIcon>
                            {capitalizeFirstLetter(String(optionLabel))}
                        </MenuItem>
                    );
                })}
            </Select>
        </FormControl>
    );
};

export default CustomSelect;
